import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link with form data
    const subject = encodeURIComponent('Inquiry from ' + formData.name);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
    );
    window.location.href = `mailto:brunchclubhospitality@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <main className="min-h-screen pt-20">
      <section className="bg-cream py-20 md:py-32">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-center text-espresso mb-8">
            Get In Touch
          </h1>
          <div className="h-1 w-24 bg-burnt-amber mx-auto mb-12"></div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-16">
            {/* Contact Information */}
            <div>
              <h2 className="font-playfair text-3xl font-bold text-espresso mb-8">
                Let's Connect
              </h2>
              <p className="font-nunito text-espresso/80 leading-relaxed mb-8">
                Have questions about our restaurants, franchising opportunities, or partnership 
                inquiries? We'd love to hear from you.
              </p>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-burnt-amber/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-burnt-amber" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-poppins font-semibold text-espresso mb-2">Email</h3>
                    <a 
                      href="mailto:brunchclubhospitality@gmail.com"
                      className="font-nunito text-burnt-amber hover:text-burnt-amber/80 transition-colors"
                    >
                      brunchclubhospitality@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-burnt-amber/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-burnt-amber" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-poppins font-semibold text-espresso mb-2">Phone</h3>
                    <a 
                      href="tel:+917753851777"
                      className="font-nunito text-burnt-amber hover:text-burnt-amber/80 transition-colors"
                    >
                      +91 7753851777
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-burnt-amber/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-burnt-amber" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-poppins font-semibold text-espresso mb-2">Instagram</h3>
                    <a 
                      href="https://instagram.com/brunchclubhospitality"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-nunito text-burnt-amber hover:text-burnt-amber/80 transition-colors"
                    >
                      @brunchclubhospitality
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl">
              <h2 className="font-playfair text-2xl font-bold text-espresso mb-6">
                Send Us a Message
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block font-poppins font-medium text-espresso mb-2">
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-warm-taupe/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-burnt-amber font-nunito"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block font-poppins font-medium text-espresso mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-warm-taupe/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-burnt-amber font-nunito"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block font-poppins font-medium text-espresso mb-2">
                    Phone
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-warm-taupe/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-burnt-amber font-nunito"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block font-poppins font-medium text-espresso mb-2">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-warm-taupe/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-burnt-amber font-nunito resize-none"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-burnt-amber hover:bg-burnt-amber/90 text-cream font-poppins font-semibold py-4 px-6 rounded-full transition-all duration-300 transform hover:scale-[1.02] uppercase tracking-wide"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;

